import React from 'lib/react';
import {
  EVGrid, EVPaper, EVTypography,
} from 'lib/components';
import { IMAGE_FILES_PATH, CLIENT_ERROR_RESPONSES } from 'constants/AppConstants';
import { useTranslation } from 'lib/translation';
import PageNotFoundStyles from './PageNotFoundStyles';

function PageNotFound() {
  const { t } = useTranslation();
  const classes = PageNotFoundStyles();
  return (
    <EVGrid className={classes.pageNotFoundPage}>
      <EVPaper className={classes.pageNotFoundPageContainer}>
        <EVPaper elevation={0} className={classes.pageNotFoundPageItemsContainer}>
          <EVPaper elevation={0}>
            <EVTypography className={classes.status}>{CLIENT_ERROR_RESPONSES.STATUS_NOT_FOUND}</EVTypography>
            <EVTypography className={classes.pageNotFound}>{t('page_not_found__text')}</EVTypography>
            <EVTypography className={classes.statusMessage}>{t('page_not_found__message')}</EVTypography>
          </EVPaper>
          <EVPaper elevation={0}>
            <img className={classes.redirectionPageImage} src={`${IMAGE_FILES_PATH}/redirectionPageImage.png`} alt={t('coming_soon__redirection_page')} />
          </EVPaper>
        </EVPaper>
      </EVPaper>
    </EVGrid>
  );
}

export default PageNotFound;
